import client from '../base-api';
import {IAddressBook, IAddressBookFilters, IAddressBookList} from "@/interfaces/AddressBook/IAddressBook";

const serviceURL = '/address-book/doctor';

const addressBookDoctorService = {

    getDoctors(filterData: IAddressBookFilters):Promise <{data: IAddressBookList}> {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getDoctor(doctorId: number): Promise <{data: {data: IAddressBook & { doctorNumber: string } }}>  {
        return client.get(`${serviceURL}/${doctorId}`);
    },
    postDoctor(doctorData: IAddressBook) {
        return client.post(`${serviceURL}`, doctorData);
    },
    putDoctor(doctorData: IAddressBook, doctorId: number) {
        return client.put(`${serviceURL}/${doctorId}`, doctorData);
    },
    deleteDoctor(doctorId: number){
        return client.delete(`${serviceURL}/delete/${doctorId}`);
    },

};

export default addressBookDoctorService;
  